var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }
    },
    [
      _c("path", {
        staticClass: "login_svg",
        attrs: {
          id: "形状_1",
          "data-name": "形状 1",
          d:
            "M1292,477.67a3.341,3.341,0,0,1,0,6.681,3.345,3.345,0,0,1-3.33-3.57,3.337,3.337,0,0,1,3.12-3.09,0.65,0.65,0,0,1,.21-0.021m0,11.67a16.845,16.845,0,0,1,5.62,1.128c1.67,0.668,2.71,1.5,2.71,2.192v1.691h-16.66V492.66c0-.689,1.04-1.524,2.7-2.192a16.943,16.943,0,0,1,5.63-1.128m0-13.34h-0.29a5.047,5.047,0,0,0-4.71,4.655,5,5,0,1,0,5-4.655h0Zm0,11.67c-3.33,0-10,1.67-10,4.99v2.5a0.833,0.833,0,0,0,.83.835h18.34a0.833,0.833,0,0,0,.83-0.835v-2.526c0-3.3-6.67-4.969-10-4.969h0Zm0,0",
          transform: "translate(-1282 -476)"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }